import { Alert } from 'components/ui';
import styled from 'styled-components';

export const StyledAlert = styled(Alert)`
  background-color: ${({ theme }) => theme.teal};
  left: 0;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 101;

  .ant-alert-message {
    color: ${({ theme }) => theme.secondaryBackgroundColor};
    text-align: center;
  }
`;
